import { Routes } from '@angular/router';
import { Error } from './features/error/error';
import { isAuthenticatedGuard } from './core/guards/is-authenticated-guard';
import { RoleGuard } from '@core/guards/role-guard';

export const routes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('./features/auth/auth.routes').then(m => m.routes),
    },
    {
        path: '',
        loadChildren: () => import('./features/main/main.routes').then(m => m.routes),
        canActivate: [isAuthenticatedGuard],
    },
    {path: 'error/:code', component: Error},
    {path: '**', redirectTo: 'error/404'},
];
